import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.VehicleModel.Save.IRequest;
type Response = Api.Core.VehicleModel.Save.IResponse;
type Headers = Api.Core.VehicleModel.Save.IHeaders;
const url = '/api/ProductManagement/VehicleModel';
export default async function vehicleModelSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
